// extracted by mini-css-extract-plugin
module.exports = {"colonne":"Partners_colonne__1aH5R","image":"Partners_image__2D_XY","container":"Partners_container__1wXQr","texte":"Partners_texte__20gCk","mobile":"Partners_mobile__1JkED"};